<template>

  <!-- start::component container -->
  <div id="page-settings-sync">

    <!-- start::title -->
    <vs-row class="mb-5" vs-align="center">
      <vs-col vs-w="12">
        <h2 class="breadcrumb">Dynamic Pricing</h2>
      </vs-col>
    </vs-row>
    <!-- end::title -->

    <!-- start::section platforms -->
    <div class="vx-card p-6">
      <div class="vx-row">
        <!-- start::platform selection column -->
        <div class="vx-col md:w-1/3 w-full">

          <!-- start::section title -->
          <div class="flex items-end mb-3">
            <feather-icon icon="ShoppingBagIcon" class="mr-2" svgClasses="w-5 h-5"/>
            <h4 class="leading-none font-medium text-primary">Πλατφόρμα</h4>
          </div>
          <!-- end::section title -->
          <p>
            Επιλέξτε την πλατφόρμα που θέλετε να συνδέσετε.
          </p>

          <vs-divider/>

          <!-- start::field platforms -->
          <div class="vx-row mt-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Platforms: </span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <v-select :clearable="true" label="name" v-model="selectedPlatform"
                        :options="platforms" @input="selectPlatform"/>
            </div>
          </div>
          <!-- end::field platforms -->
        </div>
        <!-- end::platform selection column -->
        <!-- start::platform connections column -->
        <div v-if="selectedPlatform" class="vx-col md:w-2/3 w-full">

          <div class="vx-card mt-base no-shadow card-border">
            <div class="vx-card__header">
              <div class="vx-card__title">
                <div class="flex items-end mb-3">
                  <feather-icon icon="SettingsIcon" class="mr-2" svgClasses="w-5 h-5"/>
                  <h4 class="leading-none font-medium text-primary" v-if="selectedPlatform">{{selectedPlatform.name}}</h4>
                </div>
              </div>
            </div>
            <div class="vx-card__collapsible-content vs-con-loading__container">
              <div class="vx-card__body">
                <p>
                  Συμπληρώστε τα παρακάτω στοιχεία για να συνδέσετε την πλατφόρμα {{selectedPlatform.name}}
                </p>
                <p class="mt-2">
                  Για την επιτυχή σύνδεση με {{selectedPlatform.name}}  χρειάζονται τα παρακάτω στοιχεία:
                </p>
                <span v-if="selectedPlatform && selectedPlatform.name == 'Woocommerce' ">
                   <vs-list>
                      <vs-list-header icon-pack="feather" icon="icon-shield" :title="selectedPlatform.name + ' Settings'"></vs-list-header>
                      <vs-list-item icon-pack="feather" icon="icon-check" title="store_url" subtitle="Μπορείτε να το βρείτε στο Wordpress από το μενού Settings->General->WordPress Address (URL)"></vs-list-item>
                      <vs-list-item icon-pack="feather" icon="icon-check" title="consumer_key" subtitle="Μπορείτε να τα βρείτε ή να τα δημιουργήσετε στο Wordpress από το μενού Woocommerce->Settings->Advanced->REST API"></vs-list-item>
                      <vs-list-item icon-pack="feather" icon="icon-check" title="consumer_secret" subtitle="Μπορείτε να τα βρείτε ή να τα δημιουργήσετε στο Wordpress από το μενού Woocommerce->Settings->Advanced->REST API"></vs-list-item>
                  </vs-list>
                  <vx-list :list="list"></vx-list>
                </span>
                <p class="mt-2">
                  Μετά την αποθήκευση πρέπει να γίνουν import τα προϊόντα. Για import πατήστε το κουμπί {{ selectedPlatform.name }} Import
                </p>
                <vs-divider/>
                <!-- start::field platforms connections fields -->
                <div v-if="localPlatformConnection" class="vx-row mt-6 mb-6">
                  <div v-for="(field, index) in localPlatformConnection" :key="field.id" class="vx-col md:w-1/3 w-full">
                    <vs-input v-if="field.type === 'text'" v-model="field.value" :label="field.name" class="w-full"></vs-input>
                    <vs-input v-else-if="field.type === 'number'" type="number" v-model="field.value" :label="field.name" class="w-full"></vs-input>
                  </div>
                </div>
                <!-- end::field platforms connections fields -->
              </div>
            </div>
          </div>
        </div>
        <!-- end::platform connections column -->
      </div>

      <div class="vx-row" v-if="selectedPlatform">
        <vs-divider/>
        <!-- start::submit button -->
        <div class="vx-col md:w-1/2 w-full">
          <div class="mt-2 flex flex-wrap items-center justify-start">
            <vs-button color="warning" :disabled="!selectedPlatform || !hasPlatformConnection" class="mt-2" @click="importProducts">
              {{ selectedPlatform.name }} Import Products
            </vs-button>
            <vs-button color="success" :disabled="!selectedPlatform || !hasPlatformConnection" class="ml-2 mt-2" @click="updateProducts">
              {{ selectedPlatform.name }} Update Products
            </vs-button>

          </div>
        </div>
        <!-- end::submit button -->
        <!-- start::platform sync buttons -->
        <div class="vx-col md:w-1/2 w-full" v-if="selectedPlatform">
          <div class="mt-2 flex flex-wrap items-center justify-end">
            <vs-button :disabled="!selectedPlatform" class="mt-2 mr-2" @click="savePlatform">
              Αποθήκευση
            </vs-button>
          </div>
        </div>
        <!-- end::platform sync buttons -->
      </div>

    </div>
    <!-- end::section platforms -->

  </div>
  <!-- end::component container -->

</template>

<script>

import vSelect from "vue-select";

export default {
  name: "SettingDynamicPricing",
  components: {vSelect},
  data() {
    return {
      list: [],
      localPlatformConnection: [],
    }
  },
  computed: {
    platforms() {
      return this.$store.getters.getAvailablePlatforms
    },
    hasPlatformConnection() {
      if (this.platform_connection.length==0) {
        return false
      }
      let empty = false
      this.platform_connection.forEach(connection => {
        if (!connection.value || connection.value.length === 0) {
          console.log('connection.value', connection.value)
        }
      })
      this.localPlatformConnection.forEach(connection => {
        if (!connection.value || connection.value.length === 0) {
          empty = true
        }
      })
      if (empty) {
        return false
      }
      return true
    },
    platform_connection: {
      get() {
        return this.$store.getters.getPlatformConnectionFields
      },
      set(value) {
        this.$store.dispatch('updatePlatformConnectionFields', value)
        .then(() => {
          this.$vs.notify({
            color: 'success',
            title: 'Επιτυχία',
            position: 'top-right',
            text: 'Οι αλλαγές σας αποθηκεύτηκαν.',
          })
        })
        .catch((err) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Σφάλμα',
            position: 'top-right',
            text: 'Υπήρξε κάποιο πρόβλημα και τα δεδομένα δεν αποθηκεύτηκαν.',
          })
          console.error(err)
        })
      }
    },
    selectedPlatform: {
      get() {
        return this.$store.getters.getSelectedPlatform
      },
      set(value) {
        this.$store.dispatch('setSelectedPlatform', value)
      }
    },
  },
  methods: {
    importProductsAction() {
      let vm = this
      vm.$store.dispatch('platformProductsImport').then(() => {
        this.$vs.notify({
          color: 'success',
          title: 'Επιτυχία',
          position: 'top-right',
          text: 'τα προϊόντα αποθηκεύτηκαν.',
        })
      })
      .catch((err) => {
        this.$vs.notify({
          color: 'danger',
          title: 'Σφάλμα',
          position: 'top-right',
          text: 'Υπήρξε κάποιο πρόβλημα και τα προϊόντα δεν εισήχθησαν.',
        })
        console.error(err)
      })
    },
    updateProductsAction() {
      let vm = this
      vm.$store.dispatch('platformProductsUpdate').then(() => {
        this.$vs.notify({
          color: 'success',
          title: 'Επιτυχία',
          position: 'top-right',
          text: 'τα προϊόντα ενημερώθηκαν.',
        })
      })
      .catch((err) => {
        this.$vs.notify({
          color: 'danger',
          title: 'Σφάλμα',
          position: 'top-right',
          text: 'Υπήρξε κάποιο πρόβλημα και τα προϊόντα δεν ενημερώθηκαν.',
        })
        console.error(err)
      })
    },
    importProducts() {
      let vm = this
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: `Επιβεβαίωση`,
        text: 'Είστε σίγουροι ότι θέλετε να εισάγετε τα προϊόντα από το '+vm.selectedPlatform.name+'; Τα ήδη υπάρχοντα προϊόντα θα διαγραφούν.',
        acceptText: 'Εισαγωγή',
        cancelText: 'Ακύρωση',
        accept: this.importProductsAction
      })

    },
    updateProducts() {
      let vm = this
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: `Επιβεβαίωση`,
        text: 'Είστε σίγουροι ότι θέλετε να ενημερώσετε τα προϊόντα από το '+vm.selectedPlatform.name+'; Τα ήδη υπάρχοντα προϊόντα δεν θα διαγραφούν.',
        acceptText: 'Ενημέρωση',
        cancelText: 'Ακύρωση',
        accept: this.updateProductsAction
      })

    },
    savePlatform() {
      let vm = this
      vm.$store.dispatch('updateSelectedPlatform', vm.selectedPlatform).then(() => {
        vm.platform_connection = vm.localPlatformConnection
      })

    },
    selectPlatform() {
      let vm = this
      if (vm.selectedPlatform) {
        vm.$store.dispatch('fetchPlatformConnectionFields', vm.selectedPlatform.id).then(() => {
          vm.localPlatformConnection = JSON.parse(JSON.stringify(vm.platform_connection))
        })
      }
    },
  },
  mounted() {
    let vm = this
    this.$store.dispatch('fetchAvailablePlatforms').then(() => {
      vm.selectedPlatform = vm.platforms.find(x => x.isConnected === 1)
      if (vm.selectedPlatform) {
        vm.$store.dispatch('fetchPlatformConnectionFields', vm.selectedPlatform.id).then(() => {
          vm.localPlatformConnection = JSON.parse(JSON.stringify(vm.platform_connection))
        })
      }
    })

  },
}
</script>

<style scoped>
.d-none {
  display: none;
}
</style>
